import React, {useContext, useState, useEffect} from 'react';
import styles from '../AuthForms.module.sass';
import cn from 'classnames';
import { ConquerContext } from '../../../contexts/ConquerContext';
import { UserContext } from '../../../contexts/UserContext';
import { AUTH_ZONE } from '..';
import Loader from '../../LoaderCircle';

const EmailVerificationForm = ({ onFinishCallback, email }) => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );

    
    const [verificationCode, setVerificationCode] = useState( '' );
    const [error, setError] =  useState( '' );
    const [sendTimer, setSendTimer] = useState( 0 );

    const [isLoading, setIsLoading] = useState( false );
    
    function showError( message ){
        
        setError( message );
        return false;
        
    }
    
    async function tryToSendVerificationCode(){

        if( sendTimer != 0 ) return showError( 'Please wait a bit to send a new code.' );
        if( !userContext.userData || !userContext.userData.username ) return showError( 'There was an error when getting your email. Please reload the page' );

        setSendTimer( 10 );

        setIsLoading( true );
        let response = await conquer.Auth.resend( {username: email || userContext.userData.username} );
        setIsLoading( false );

    }

    async function tryToVerify(){

        setError('');

        if( !userContext.userData || !userContext.userData.username ) return showError( 'There was an error when getting your email. Please reload the page' );
        if( !verificationCode || verificationCode.length != 4 ) return showError( 'You have to provide a valid verification code.' );

        setIsLoading( true );
        let response = await conquer.Auth.verify( { username: email || userContext.userData.username, code: verificationCode } );
        setIsLoading( false );

        if( response.error ) return showError( response.error );

        onFinishCallback?.();

    }

    function tryToLogout(){
        conquer.Auth.logout();
    }

    function updateSendTimer(){

        let newTime = sendTimer - 1;
        if( newTime < 0 ) newTime = 0; 
        setSendTimer( newTime );

    }

    useEffect(() => {
        let interval;
        if( sendTimer > 0) interval = setInterval(updateSendTimer, 1000);
    
        return () => {if( interval ) clearInterval(interval)};
    }, [sendTimer]);

    return (
        <div className={'form'}>
            <div className={styles.form__column}>
                <div className={'fields_container'}>
                    <input
                        type='text'
                        placeholder='Code'
                        className={error && !isLoading ? 'error' : ''}
                        max='4'
                        min='4'
                        onChange={(event) => { setVerificationCode(event.target.value) }}
                    />
                </div>
                <div className={'form_bottom'}>
                    <button onClick={tryToSendVerificationCode} className={'helperLink'}>
                        Send Again {sendTimer > 0 && <span>({sendTimer}s)</span>} 
                    </button>
                </div>
                { isLoading ? 
                    <Loader /> : 
                    <div className={'btn_container'}>
                        <button className={cn('button', 'secondary')} onClick={tryToLogout}>
                            Back
                        </button>
                        <button className={cn('button','primary')} onClick={tryToVerify}>
                            Verify
                        </button>
                    </div>
                }
                {error && <p className={'error'} style={{textAlign:'left'}}>{error}</p>}
            </div>
        </div>
    );
};

export default EmailVerificationForm;
